










import Vue from "vue";
import { mapState } from "vuex";
export default Vue.extend({
  props: {
    overlay: {
      type: Boolean,
      default: false
    },
    borderWidth: {
      type: Number,
      default: 4
    },
    diameter: {
      type: Number,
      default: 60
    },
    unique: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    condition() {
      return (this.unique && this.loading) || (!this.unique && this.active);
    },
    loaderStyle() {
      return {
        borderWidth: this.borderWidth + "px",
        width: this.diameter + "px",
        height: this.diameter + "px"
      };
    },
    ...mapState({
      active: (state: any) => state.loadersModule.globalLoader
    })
  }
});
